/**
 * The daily crawl-schedule boundary, shared by anything that needs to anchor a "since the last
 * crawl" window instead of a rolling window against once-a-day batch arrivals (see
 * `server/utils/nav-pulse.ts`'s doc comment on `mostRecentCrawlStartMs` for the full rationale:
 * a rolling window against a once-daily batch produces a false "quiet day" sawtooth).
 *
 * This lives in `utils/search-router` (not `server/`) because both a server-only consumer
 * (`server/utils/nav-pulse.ts`, which re-exports it for backward compatibility) and an
 * isomorphic one (`first-seen-threshold.ts`, imported from client components) need it, and this
 * file has no server-only dependencies (no Typesense client, no AWS creds), so it is safe in
 * either bundle.
 */
export const CRAWL_SCHEDULE_UTC_HOUR = 7;

/** The most recent crawl-start timestamp (07:00 UTC) at or before `now`. */
export function mostRecentCrawlStartMs(now: number): number {
  const boundary = new Date(now);
  boundary.setUTCHours(CRAWL_SCHEDULE_UTC_HOUR, 0, 0, 0);
  if (boundary.getTime() > now) boundary.setUTCDate(boundary.getUTCDate() - 1);
  return boundary.getTime();
}
